import { render, staticRenderFns } from "./ClientSearchAreaSale.vue?vue&type=template&id=cd7b6122&scoped=true&"
import script from "./ClientSearchAreaSale.vue?vue&type=script&lang=js&"
export * from "./ClientSearchAreaSale.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchAreaSale.vue?vue&type=style&index=0&id=cd7b6122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7b6122",
  null
  
)

export default component.exports